import { render, staticRenderFns } from "./index.vue?vue&type=template&id=8f485d64"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {IconsQuestionMark: require('/opt/build/repo/components/Icons/QuestionMark.vue').default,ElementsLink: require('/opt/build/repo/components/Elements/Link.vue').default})
